/* eslint-disable no-unused-vars */
import React from "react";
import { Switch, Route } from "react-router-dom";
// creates a beautiful scrollbar
// import PerfectScrollbar from "perfect-scrollbar";
// import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Navbar from "../components/Navbars/Navbar";
import Footer from "../components/Footer/Footer";
import Sidebar from "../components/Sidebar/Sidebar";

import routes from "../routes";

import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle";

import bgImage from "../assets/img/sidebar-4.jpg";
import logo from "../assets/img/reactlogo.png";
import { connect } from "react-redux";
import SnackBarMui from "../components/SnackBarMui";

// @material Icons
import AppsIcon from '@material-ui/icons/Apps';
import TestTab from '../views/Testing';


let ps;
// add test Route here
let testRoute = {
  path: "/test",
  name: 'Test Components',
  rtlName: "اختبار",
  icon: AppsIcon,
  component: <TestTab />,
  layout: "/admin",
  navBarName:'Test'

};

const testRoutes = // routes
(process.env.NODE_ENV!=='production'||window.location.hostname==="electron-epp-test.herokuapp.com")?
  [...routes, testRoute]:
  routes;

const NestedRoutes = testRoutes.map((prop, key) => {
  if (prop.parent) {
    let nestedRoutes = prop.nestedRoutes.map((route, key2) => {
      return (<Route
        path={route.layout + route.path} // {route.path}
        // component={route.component}
        key={key2}
      >
        {route.component}
      </Route>
        );
    });
    return nestedRoutes;
  }
});

const switchRoutes = (
  <Switch>
    {NestedRoutes.map(elem => elem)}
    {testRoutes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path} // {prop.path}
            // component={prop.component}
            key={key}
          >
            {prop.component}
          </Route>
        );
      }
      return null;
    })}
    <Route path="/admin/session-expired">
      <h1 style={{textAlign:'center',background:'#ffffff', borderRadius:'1rem'}}>
        session Expired
      </h1>
    </Route>
    <Route path="*">
      <h1 style={{textAlign:'center',background:'#ffffff', borderRadius:'1rem'}}>
        404 not found.
      </h1>
    </Route>
    {/* <Redirect from="/admin" to="/admin/dashboard" /> */}
  </Switch>
);

const useStyles = makeStyles(styles);

function Admin ({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage); // '../assets/img/sidebar-4.jpg'
  const [color, setColor] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  // React.useEffect(() => {
  //   if (navigator.platform.indexOf("Win") > -1) {
  //     ps = new PerfectScrollbar(mainPanel.current, {
  //       suppressScrollX: true,
  //       suppressScrollY: false
  //     });
  //     document.body.style.overflow = "hidden";
  //   }
  //   window.addEventListener("resize", resizeFunction, {passive:true});
  //   // Specify how to clean up after this effect:
  //   return function cleanup () {
  //     if (navigator.platform.indexOf("Win") > -1) {
  //       ps.destroy();
  //     }
  //     window.removeEventListener("resize", resizeFunction);
  //   };
  // }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <SnackBarMui/>
      <Sidebar
        routes={testRoutes}
        logoText={<span>e<sup><i style={{fontWeight:'bold'}}>-</i></sup> <i>ERP</i></span>}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={testRoutes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.i18nReducer.language,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);